import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import client from 'src/client'
import { INotification } from '../types/notification.type'

type IParams = {
  userId?: string
}

export const CORE_NOTIFICATION_QUERY_KEY = 'CORE_NOTIFICATIONS'

function getQueryParams(params: { userId: string }) {
  const filterConditions: any[] = [
    {
      recipient: {
        _eq: params.userId
      }
    }
  ]

  const queryParams = {
    fields: [
      'id',
      'status',
      'url',
      'is_read',
      'timestamp',
      'subject',
      'message',
      'sender.first_name',
      'sender.last_name',
      'sender.avatar',
      'date_created'
    ],
    limit: 10,
    meta: ['total_count', 'filter_count', 'current_page', 'limit', 'total_page'],
    filter: {
      _and: filterConditions
    },
    sort: ['-timestamp', 'id']
  }

  return queryParams
}

export function useGetNotification(params: IParams) {
  const [notifications, setNotifications] = useState<INotification[]>([])
  const userId = params.userId

  const { data: initialData, isLoading } = useQuery({
    queryKey: [CORE_NOTIFICATION_QUERY_KEY, userId],
    queryFn: async () => {
      if (!userId) return []
      const { data: response } = await client.api.get<{ data: INotification[] }>('/notifications', {
        params: getQueryParams({ userId })
      })
      return response.data ?? []
    },
    enabled: Boolean(userId)
  })

  const subscription = client.mqtt.useMqttSubscription<INotification>(userId ? `notifications/${userId}` : '', {
    parser: buffer => JSON.parse(buffer.toString())
  })

  useEffect(() => {
    if (initialData) {
      setNotifications(initialData)
    }
  }, [initialData])

  useEffect(() => {
    if (subscription.message?.message) {
      setNotifications(prev => [subscription.message!.message, ...prev])
    }
  }, [subscription.message])

  return {
    data: notifications,
    isLoading,
    subscribe: () => {},
    unsubscribe: () => {}
  }
}
